<template>
  <TsMedia
    :append-class="
      twMerge(
        'border border-[#DEEFFF] bg-white rounded-lg p-3 md:p-4 md:pb-4 relative mb-3 last:mb-0 shadow-[2px_4px_8.7px_-5px_#7E9CB766]',
        props.appendClass
      )
    "
  >
    <TsMediaStart append-class="mr-2.5 max-md:absolute max-md:left-3">
      <div
        class="bg-white px-2 py-4 md:px-3 md:py-5 rounded-md border border-[#DEEFFF]"
      >
        <TsCheckbox
          size="sm"
          append-class="absolute -top-2 -left-2 lg:top-1.5 lg:left-2"
          :value="props.value"
          v-model="checkedItems"
          :data-testid="props.dataTestid + '-checkbox'"
        />
        <TsImage
          v-if="props && props.image"
          :src="props?.image"
          :alt="`trolley-product-dewalt-dril-thumbnail`"
          :width="isMobile ? '65' : '90'"
        />
      </div>
    </TsMediaStart>

    <TsMediaContent>
      <div class="max-md:ml-[5.6rem] mb-5">
        <TsTypography
          append-class="max-w-44 md:max-w-[374px] mb-0 leading-[18px] text-idle-black"
        >
          {{ props?.fullName }}
          <span class="text-natural-grey">
            {{ props?.packSize }}
          </span>
          ({{ props?.code }})
          <TsTypography
            append-class="max-w-44 md:max-w-[374px] mb-0 leading-[18px] text-idle-black mt-2"
            >{{useTranslation("quantity","Hoeveelheid")}}- {{ props?.quantity }}</TsTypography
          >
        </TsTypography>
        <div
          class="text-right ml-4 absolute bottom-4 right-4 md:top-4 md:right-4"
        >
          <slot name="price">
            <TsTypography
              variant="h2"
              weight="bold"
              append-class="leading-[24px] mb-0 whitespace-nowrap"
            >
              {{ rootStore.isIncVat ? props?.gross : props?.net }}
            </TsTypography>
            <TsTypography
              append-class="leading-[14px] mb-0 whitespace-nowrap"
              variant="xs"
            >
              {{ rootStore.isIncVat ? 'Excl. ' + useTranslation('vat' , 'btw') : 'Incl. '+ useTranslation('vat' , 'btw') }}
              {{ rootStore.isIncVat ? props?.net : props?.gross }}
            </TsTypography>
            <TsTypography
              append-class="leading-[14px] mb-0 whitespace-nowrap"
              variant="xs"
              v-if="props?.perUnit"
            >
            {{useTranslation("pricePerUnit" , "Prijs per eenheid")}} $€{{ props?.perUnit }}
            </TsTypography>
          </slot>
        </div>
      </div>
    </TsMediaContent>
  </TsMedia>
</template>

<script setup lang="ts" generic="T">
import { twMerge } from "tailwind-merge";

const TsMediaStart = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaStart.vue')
  );

const TsMediaContent = defineAsyncComponent(
    () => import('~/components/organisms/TsMediaContent.vue')
  );

const { isMobile } = useDevice();
const rootStore = useRootStore();

type Props = {
  image?: string;
  fullName?: string;
  packSize?: string;
  code?: string;
  quantity?: number;
  gross?: string | number;
  net?: string | number;
  perUnit?: string | number | null;
  appendClass?: string;
  dataTestid: string;
  value: T;
};

const props = withDefaults(defineProps<Props>(), {
  appendClass: "",
});

const checkedItems = defineModel<T[]>("check");
</script>
